import React, { useRef, useEffect, useContext, useState, useMemo } from "react";
import { Checkbox, FormGroup, FormControlLabel } from "@mui/material";
import { ArrowDropDown, FiberManualRecord, CheckCircle } from "@mui/icons-material";
import "./Flags.css";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import { FlagChips, FlagNotes } from "./Components";
import * as c from "utils/constants/constants";

const Flags = (props) => {

    const { setDocumentData, data = {}, duplicateDocumentView, setDialogs, setDataSave, updateDocumentData, docSplit} = useContext(DocumentDetailContext);
    const flagBoxRef = useRef(null);
    const [showPopup, setPopup] = useState(false);

    const flagList = useMemo(() => {
        return data.Tags;
    }, [data.Tags]);

    const selectedFlags = useMemo(() => {
        return data.Tags.filter(m => m.enabled);
    }, [data.Tags]);


    useEffect(() => {
        // Function for click event outside flag box
        function handleOutsideClick(event) {
            if (flagBoxRef.current && !flagBoxRef.current.contains(event.target)) {
                setPopup(false)
            }
        }
        // Adding click event listener
        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, [flagBoxRef]);


    const handleFlags = (event) => {
        const { checked, name } = event.target;
        let flagListCopy = JSON.parse(JSON.stringify(flagList));

        if (name == "SPAM") {
            if (checked) disableOtherFlags(flagListCopy, name);
            else {
                flagListCopy.forEach((m => {
                    m.enabled = m.tag_display_name == name ? checked : m.enabled;
                    m.disabled = false;
                }));
            }
        } else {
            flagListCopy.forEach((m => {
                if (m.tag_display_name == name) {
                    m.enabled = checked;
                }
            }));
        }

        if (name == "SPAM" && checked) {
            setDialogs(prevState => ({
                ...prevState,
                ["spamAlert"]: true
            }))
        }



        data.Tags = JSON.parse(JSON.stringify(flagListCopy));
        data.Entity_Details.selected_tags = flagListCopy.reduce((acc, m) => {
            if(m.enabled) acc.push(m.tag_display_name);
            return acc;
        }, []);
        updateDocumentData(data);
        setDataSave(true)
    }

    const disableOtherFlags = (list, flagName) => {
        list.forEach(m => {
            if (m.tag_display_name == flagName) {
                m.enabled = true;
                m.disabled = false
            } else {
                if(flagName == "SPAM") m.enabled = false;
                m.disabled = true
            }
        });
    }

    return (
        <div style={{ display: "flex", alignItems: "baseline", pointerEvents: localStorage.getItem(c.USER_ROLE) == "Admin" && data.Status == c.status.completed ? "auto" : "inherit" }}>
            <div ref={flagBoxRef}>
                <div style={{ display: "flex", alignItems: "baseline" }}>
                    <div className="fg-flag-icon" onClick={() => { !duplicateDocumentView && setPopup(!showPopup) }}>
                        <div>Flags</div>
                        <div className="fg-count">
                            <div className="fg-count-number">{selectedFlags?.length || 0}</div>
                            <ArrowDropDown />
                        </div>

                    </div>
                    <FlagChips selectedFlags={selectedFlags} />
                </div>
                {showPopup &&
                    <div className="fg-popup">
                        <div>
                            <div className="fg-data">
                                {(flagList || []).map((flag, i) => (
                                    <div key={i}>
                                        <FormGroup>
                                            <FormControlLabel
                                                name={flag.tag_display_name}
                                                sx={{
                                                    "span": {
                                                        color: flag.disabled ? "var(--text-grey) !important" : "var(--text-primary) !important",
                                                        opacity: flag.disabled ? 0.5 : 1
                                                    },
                                                    "svg": {
                                                        color: flag.disabled ? "var(--text-grey) !important" : "var(--hti-magenta-light) !important",
                                                        opacity: flag.disabled ? 0.5 : 1
                                                    }
                                                }}
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={flag.enabled}
                                                        disabled={flag.disabled}
                                                        className="check-box-color"
                                                        onChange={handleFlags}
                                                    />
                                                }
                                                label={flag.tag_display_name}
                                                labelPlacement="end"
                                            />
                                        </FormGroup>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>}

            </div>
            {!docSplit.isDocSplitEnabled && <FlagNotes />}
        </div>
    );
};

export default Flags;
